// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"ca05b665","725":"23e2143f"}[chunkId] + ".js";
};